<template>
    <v-container fluid fill-height px-0 class="main-container container-fixed d-block">
        <div class="content-block">
            <v-flex class="d-flex justify-space-between align-center mx-6">
                <div class="arrow-btn main-text d-inline-flex" @click="back">
                    <div
                        v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')"
                        class="size-28 rotate-90"
                    />
                </div>
                <div class="title-text d-inline-flex">
                    {{ deviceData.name }}
                </div>
                <div class="d-inline-flex" style="width: 28px"></div>
            </v-flex>
            <v-layout row v-if="deviceData" class="ma-0 px-6 mb-2 w-100 justify-center">
                <span class="main-text ml-1" v-if="deviceData.location">
                    ({{ deviceData.location }})
                </span>
            </v-layout>
            <v-layout column ma-0 class="main-text w-100 history-list scrollbar-block" v-if="lightings.length > 0">
                <v-flex
                    xs12
                    v-for="(lighting, index) in lightings"
                    :key="index" class="history"
                    :class="{'history__high': lighting.new_day}"
                >
                    <v-layout v-if="lighting.new_day" class="history__title main-text">
                        {{lighting.new_day}}
                    </v-layout>
                    <v-flex class="history-row">
                        <div class="history-row__time">
                            <div class="d-flex align-center">
                                <div class="d-inline-flex" v-if="lighting.state.value">
                                    <div
                                        v-html="require('!html-loader!@/assets/device-icons/lighting.svg')"
                                        class="size-30"
                                    />
                                </div>
                                <div class="d-inline-flex disabled-image" v-else>
                                    <div
                                        v-html="require('!html-loader!@/assets/device-icons/lighting_off.svg')"
                                        class="size-30"
                                    />
                                </div>
                                <div class="time-row bold-text d-inline-flex ml-2">
                                    время: <span class="main-text ml-1">{{lighting.start_updated}}</span>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <div class="d-flex align-center history-list__error" v-else>
                <v-flex class="d-block text-center">
                    <div>
                        <div
                            v-html="require('!html-loader!@/assets/images/error.svg')"
                            class="d-inline-flex mb-8"
                        />
                        <div class="common-text text-center">
                            Нет истории
                        </div>
                    </div>
                </v-flex>
            </div>
            <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";
import {getTimeFromDate} from "@/utils";

export default {
    name: "LightingHistory",
    components: {
        ModalWaiting,
    },
    data() {
        return {
            deviceUID: null,
            deviceData: {},
            lightings: [],
            openModalWaiting: false,
            month: ["января", "февраля", "марта", "апреля", "мая", "июня", "июля", "августа", "сентября", "октября", "ноября", "декабря"],
        };
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.params.id;
            if (this.deviceUID) {
                this.getLightings();
            }
        },
        getLightings() {
            this.lightings = [];
            this.openModalWaiting = true;
            this.$http.get('/devices/home/lighting-on-off-history/' + this.deviceUID + '/')
                .then((res) => {
                    this.deviceData = res.data.device;
                    this.lightings = res.data.actions;
                    this.lightings.forEach((lighting, index) => {
                        lighting.start_updated = this.getTime(lighting.date);
                        if (index > 0) {
                            if (this.checkDay(lighting.date) != this.checkDay(this.lightings[index - 1].date)) {
                                lighting.new_day = this.getDateTime(lighting.date);
                            }
                        } else {
                            lighting.new_day = this.getDateTime(lighting.date);
                        }
                    });
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        getTime(time) {
            return getTimeFromDate(time);
        },
        checkDay(day) {
            return day.split(' ')[0];
        },
        getDateTime(date_time) {
            let offsetDate = date_time.split(' ')[0];
            let parsedDate = offsetDate.split('-');
            return parsedDate[2] + " " + this.month[parseInt(parsedDate[1]) - 1] + " " + parsedDate[0];
        },
        back() {
            this.$router.push({ name: "homepage" });
        },
    },
}
</script>

<style lang="scss" scoped>
.rotate-90.v-image {
    transform: rotate(90deg);
}
</style>